'use client'

import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'motion/react'

const Hero = () => {
	const containerRef = useRef(null)
	const yearsOfExperience = new Date().getFullYear() - 2017

	const { scrollYProgress } = useScroll({
		target: containerRef,
		offset: ['start start', 'end start']
	})

	const y = useTransform(scrollYProgress, [0, 1], [0, 300])
	const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0])
	const scale = useTransform(scrollYProgress, [0, 0.5], [1, 0.95])

	return (
		<motion.section
			ref={containerRef}
			className="relative min-h-screen flex items-center justify-center overflow-hidden"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.8 }}
		>
			{/* Background gradient */}
			<motion.div
				className="absolute inset-0 z-0"
				style={{ y, opacity, scale }}
			>
				<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-linear-to-tr from-green-400/20 to-emerald-500/20 blur-3xl" />
			</motion.div>

			{/* Content */}
			<div className="relative z-10 text-center max-w-4xl px-6">
				<motion.h1
					className="text-5xl md:text-7xl font-bold mb-6 tracking-tight"
					initial={{ opacity: 0, y: 30 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
				>
					<span className="block text-gray-900 dark:text-white">Hi, I&apos;m</span>
					<span className="text-gradient">Daniel Varga</span>
				</motion.h1>

				<motion.p
					className="text-xl md:text-2xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.4 }}
				>
					Software Engineer with {yearsOfExperience} years of experience creating beautiful, functional, and user-centered digital experiences.
				</motion.p>
			</div>

			{/* Scroll indicator */}
			<motion.div
				className="absolute bottom-10 left-1/2 -translate-x-1/2"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, y: [0, 8, 0] }}
				transition={{
					opacity: { delay: 1, duration: 0.5 },
					y: { duration: 2, repeat: Infinity, ease: 'easeInOut' }
				}}
			>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-gray-400">
					<path d="M12 5L12 19M12 19L19 12M12 19L5 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</motion.div>
		</motion.section>
	)
}

export default Hero
